// extracted by mini-css-extract-plugin
module.exports = {"control":"HeadingLink_control__T_ZYZ","visibility":"HeadingLink_visibility__QXLC9","text":"HeadingLink_text__zkJDS"};